import { NgModule } from '@angular/core';
import { DashboardPageRoutingModule } from './dashboard-routing.module';
import { DashboardPage } from './dashboard.page';
import { SearchComponentModule } from 'src/app/components/search/search.component.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { RangeDatePickerComponentModule } from 'src/app/components/range-date-picker/range-date-picker.module';
import { DraggableSliderComponentModule } from 'src/app/components/draggable-slider/draggable-slider.component.module';
import { DatePickerModule } from 'src/app/components/date-picker/date-picker.module';
import { WebBillListComponentModule } from 'src/app/components/web-bill-list/web-bill-list.module';
import { ErrorAlertModalComponentModule } from 'src/app/components/alert-modal/error-alert-modal.module';
import { IonDateTimePickerModule } from 'src/app/components/ion-date-time-picker/ion-date-time-picker.module';

@NgModule({
  imports: [
    SharedModule,
    SearchComponentModule,
    RangeDatePickerComponentModule,
    DraggableSliderComponentModule,
    DashboardPageRoutingModule,
    ErrorAlertModalComponentModule,
    IonDateTimePickerModule,
    WebBillListComponentModule,
    DatePickerModule
  ],
  declarations: [DashboardPage]
})
export class DashboardPageModule {}
